// extracted by mini-css-extract-plugin
module.exports = {"holder":"ContactContetStyle-module--holder--1X0PH","label":"ContactContetStyle-module--label--1hCSz"};